import React from 'react';
import { SectionWrapper, Countdown, Button } from './ui';
import { AlertTriangleIcon } from 'lucide-react';
export const Urgency = () => {
  return <div className="bg-dark-card border-y border-dark-border py-12 text-center" data-id="element-161">
      <div className="max-w-3xl mx-auto px-4" data-id="element-162">
        <div className="flex items-center justify-center gap-2 text-accent mb-6" data-id="element-163">
          <AlertTriangleIcon size={24} data-id="element-164" />
          <h2 className="text-xl md:text-2xl font-bold uppercase tracking-wider" data-id="element-165">
            Precio de lanzamiento — Cierra en:
          </h2>
        </div>

        <div className="mb-8" data-id="element-166">
          <Countdown data-id="element-167" />
        </div>

        <p className="text-xl text-red-400 font-bold mb-8" data-id="element-168">
          ⚠️ Después sube $8.000 ARS. No vuelve.
        </p>

        <div className="max-w-md mx-auto" data-id="element-169">
          <div className="flex justify-between text-sm text-cyan-100/70 mb-2 font-medium" data-id="element-170">
            <span data-id="element-171">Cupos al precio de lanzamiento</span>
            <span data-id="element-172">Quedan pocos</span>
          </div>
          <div className="w-full bg-dark-bg rounded-full h-4 border border-dark-border overflow-hidden" data-id="element-173">
            <div className="bg-gradient-to-r from-accent via-primary to-blue-400 h-full rounded-full" style={{
            width: '71%'
          }} data-id="element-174"></div>
          </div>
          <p className="text-xs text-cyan-200/50 mt-2 text-right" data-id="element-175">
            71% de los cupos ya tomados
          </p>
        </div>
      </div>
    </div>;
};
export const PricingCards = () => {
  return <SectionWrapper id="pricing" className="bg-dark-bg" data-id="element-176">
      <div className="text-center mb-12" data-id="element-177">
        <h2 className="text-4xl md:text-5xl font-black text-white mb-4" data-id="element-178">
          ELEGÍ TU SUPERKIT IA
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto items-center" data-id="element-179">
        <div className="bg-dark-card border border-dark-border rounded-3xl p-8 shadow-xl" data-id="element-180">
          <h3 className="text-2xl font-bold text-white mb-2" data-id="element-181">
            🤖 SUPERKIT IA™
          </h3>
          <p className="text-primary font-medium mb-6" data-id="element-182">6 Tomos + 6 Bonos</p>

          <div className="bg-dark-bg rounded-xl p-4 mb-8 border border-dark-border" data-id="element-183">
            <p className="text-sm text-cyan-200/70" data-id="element-184">Ideal para:</p>
            <p className="text-white font-medium" data-id="element-185">
              Profesionales y emprendedores que quieren implementar IA en su
              trabajo real desde hoy
            </p>
          </div>

          <div className="mb-8" data-id="element-186">
            <p className="text-cyan-200/50 line-through text-xl mb-1" data-id="element-187">
              $67.000
            </p>
            <p className="text-5xl font-black text-white" data-id="element-188">
              $19.990{' '}
              <span className="text-2xl text-cyan-200/70 font-bold" data-id="element-189">ARS</span>
            </p>
          </div>

          <Button size="lg" className="w-full" href="https://www.nexorecursos.com/cart/52522004676884:1" data-id="element-190">
            → QUIERO MI SUPERKIT IA AHORA
          </Button>
        </div>

        <div className="bg-gradient-to-b from-[#0d3354] to-dark-card border-2 border-primary rounded-3xl p-8 shadow-[0_0_40px_rgba(34,211,238,0.18)] relative transform md:-translate-y-4" data-id="element-191">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-primary text-dark-bg px-6 py-1.5 rounded-full text-sm font-bold tracking-wider shadow-lg shadow-primary/40" data-id="element-192">
            MÁS ELEGIDO
          </div>

          <h3 className="text-2xl font-bold text-white mb-2" data-id="element-193">
            🚀 SUPERKIT IA™ + EL ARQUITECTO ⭐
          </h3>
          <p className="text-primary font-medium mb-6" data-id="element-194">
            6 Tomos + 6 Bonos + Manual El Arquitecto de Sistemas IA
          </p>

          <div className="bg-dark-bg/50 rounded-xl p-4 mb-8 border border-primary/30" data-id="element-195">
            <p className="text-sm text-primary" data-id="element-196">Ideal para:</p>
            <p className="text-white font-medium" data-id="element-197">
              Dueños de negocio y profesionales de alto perfil que quieren dejar
              de ser operadores y convertirse en Arquitectos de sistemas que
              trabajan solos
            </p>
          </div>

          <div className="mb-8" data-id="element-198">
            <p className="text-cyan-200/50 line-through text-xl mb-1" data-id="element-199">
              $89.000
            </p>
            <p className="text-5xl font-black text-white" data-id="element-200">
              $27.990{' '}
              <span className="text-2xl text-cyan-200/70 font-bold" data-id="element-201">ARS</span>
            </p>
          </div>

          <Button size="lg" className="w-full text-lg shadow-[0_0_20px_rgba(34,211,238,0.4)]" href="https://www.nexorecursos.com/cart/52522005496084:1" data-id="element-202">
            → QUIERO EL SUPERKIT IA + EL ARQUITECTO
          </Button>
        </div>
      </div>
    </SectionWrapper>;
};
export const Accelerator = () => {
  const comparisons = [{
    sit: 'Usás la IA para tareas sueltas',
    sin: 'Operador eficiente con límite de impacto',
    con: 'Arquitecto con sistema que opera solo'
  }, {
    sit: 'La IA no te conoce ni recuerda tu negocio',
    sin: 'Explicás todo desde cero en cada conversación',
    con: 'Custom Instructions que personalizan la IA para vos siempre'
  }, {
    sit: 'Necesitás pensar estratégicamente',
    sin: 'Lo hacés vos solo con la información que tenés',
    con: 'CEO Virtual que analiza, diagnostica y recomienda'
  }, {
    sit: 'Tus ventas no crecen como querías',
    sin: 'Sin sistema de growth definido',
    con: 'Growth Hacker virtual que diseña campañas de revenue'
  }, {
    sit: 'Comunicaciones delicadas te generan ansiedad',
    sin: 'Improvisás y rezás que salga bien',
    con: 'Comunicador que maneja crisis y redacta perfecto'
  }, {
    sit: 'Tu negocio depende de tu presencia',
    sin: 'Cuello de botella permanente',
    con: 'COO Digital que audita y optimiza la operación'
  }, {
    sit: 'No entendés tus números reales',
    sin: 'Decisiones basadas en intuición',
    con: 'CFO Inteligente que analiza y alerta en tiempo real'
  }];
  return <SectionWrapper className="bg-dark-card/30" data-id="element-203">
      <div className="text-center mb-12" data-id="element-204">
        <h2 className="text-3xl md:text-5xl font-black text-white mb-4" data-id="element-205">
          🚀 ¿QUÉ AGREGA EL ARQUITECTO DE SISTEMAS IA?
        </h2>
      </div>

      <div className="max-w-5xl mx-auto" data-id="element-206">
        <div className="overflow-x-auto rounded-xl border border-dark-border shadow-xl" data-id="element-207">
          <table className="w-full text-left border-collapse min-w-[700px]" data-id="element-208">
            <thead data-id="element-209">
              <tr className="bg-dark-card border-b border-dark-border" data-id="element-210">
                <th className="p-4 text-sm font-bold text-cyan-200/70 uppercase" data-id="element-211">
                  Situación en tu negocio
                </th>
                <th className="p-4 text-sm font-bold text-red-400 uppercase border-l border-dark-border bg-red-950/10" data-id="element-212">
                  ❌ Sin El Arquitecto
                </th>
                <th className="p-4 text-sm font-bold text-primary uppercase border-l border-dark-border bg-primary/5" data-id="element-213">
                  ✅ Con El Arquitecto
                </th>
              </tr>
            </thead>
            <tbody data-id="element-214">
              {comparisons.map((item, i) => <tr key={i} className="border-b border-dark-border/50 hover:bg-dark-card/50 transition-colors" data-id="element-215">
                  <td className="p-4 text-cyan-50 font-medium" data-id="element-216">{item.sit}</td>
                  <td className="p-4 text-cyan-100/70 border-l border-dark-border/50 bg-red-950/5" data-id="element-217">
                    {item.sin}
                  </td>
                  <td className="p-4 text-white font-medium border-l border-dark-border/50 bg-primary/5" data-id="element-218">
                    {item.con}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </SectionWrapper>;
};
export const FinalCTA = () => {
  return <div className="bg-dark-card border-y border-dark-border py-16" data-id="element-219">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-220">
        <h2 className="text-2xl md:text-3xl font-black text-white mb-6 uppercase tracking-wider" data-id="element-221">
          ⏰ EL PRECIO CIERRA EN:
        </h2>

        <div className="mb-12" data-id="element-222">
          <Countdown data-id="element-223" />
        </div>

        <div className="grid md:grid-cols-2 gap-6 text-left mb-10" data-id="element-224">
          <div className="bg-dark-bg border border-dark-border rounded-2xl p-6 flex flex-col justify-between" data-id="element-225">
            <div data-id="element-226">
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-227">
                🤖 SUPERKIT IA™
              </h3>
              <div className="mb-6" data-id="element-228">
                <span className="text-cyan-200/50 line-through mr-2" data-id="element-229">
                  $67.000
                </span>
                <span className="text-3xl font-black text-white" data-id="element-230">
                  $19.990 ARS
                </span>
              </div>
            </div>
            <Button size="md" className="w-full" href="https://www.nexorecursos.com/cart/52522004676884:1" data-id="element-231">
              → QUIERO MI SUPERKIT IA AHORA
            </Button>
          </div>

          <div className="bg-gradient-to-b from-[#0d3354] to-dark-bg border-2 border-primary rounded-2xl p-6 flex flex-col justify-between relative" data-id="element-232">
            <div data-id="element-233">
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-234">
                🚀 SUPERKIT IA™ + EL ARQUITECTO ⭐
              </h3>
              <div className="mb-6" data-id="element-235">
                <span className="text-cyan-200/50 line-through mr-2" data-id="element-236">
                  $89.000
                </span>
                <span className="text-3xl font-black text-white" data-id="element-237">
                  $27.990 ARS
                </span>
              </div>
            </div>
            <Button size="md" className="w-full" href="https://www.nexorecursos.com/cart/52522005496084:1" data-id="element-238">
              → QUIERO EL SUPERKIT IA + EL ARQUITECTO
            </Button>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-cyan-100/80 font-medium" data-id="element-239">
          <span data-id="element-240">✅ Pago 100% seguro</span>
          <span data-id="element-241">✅ Acceso en 5 minutos</span>
          <span data-id="element-242">✅ Garantía 7 días</span>
          <span data-id="element-243">✅ Mercado Pago</span>
          <span data-id="element-244">✅ Transferencia bancaria</span>
        </div>
      </div>
    </div>;
};